import { useEffect, useState } from 'react';
import merge from 'lodash/merge';

const DEFAULT_OPTIONS = {
  async: true,
};

const useScript = ({ options, parentNode, url }) => {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);
  
  useEffect(() => {
    const script = document.createElement('script');
    const attributes = merge(DEFAULT_OPTIONS, options);
    
    script.src = url;
    Object.entries(attributes).forEach(([key, value]) => {
      script[key] = value;
    });

    const onScriptLoad = () => {
      setLoaded(true);
      setError(false);

      if (options.onLoad) {
        options.onLoad();
      }
    };

    const onScriptError = () => {
      setLoaded(false);
      setError(true);

      if (options.onError) {
        options.onError();
      }
    };

    script.addEventListener('load', onScriptLoad);
    script.addEventListener('error', onScriptError);

    const node = parentNode || document.body;
    node.appendChild(script);

    return () => {
      script.removeEventListener('load', onScriptLoad);
      script.removeEventListener('error', onScriptError);

      node.removeChild(script);
    };
  }, [options, parentNode, url]);

  return { loaded, error };
};

export default useScript;
